export default __webpack_public_path__ + "static/media/minus.f57fc069.svg";